<template>
  <div>
    <CCard no-body class="content-fade-in form-basic">
      <CCardBody>
        <CForm>
          <CRow>
            <CCol sm="6" md="6" xl="6">
              <BaseInput
                :options="firstNameInput.options"
                :data="firstNameInput.data"
              />
            </CCol>
            <CCol sm="6" md="6" xl="6">
              <BaseInput
                :options="lastNameInput.options"
                :data="lastNameInput.data"
              />
            </CCol>
            <CCol sm="6" md="6" xl="6">
              <BaseInput
                :options="fullNameInput.options"
                :data="fullNameInput.data"
              />
            </CCol>
            <CCol sm="6" md="6" xl="6">
              <BaseSelect
                :options="genderSelect.options"
                :data="genderSelect.data"
                ref="genderSelect"
              >
              </BaseSelect>
            </CCol>
            <CCol sm="6" md="6" xl="6">
              <BaseInput
                :options="statusInput.options"
                :data="statusInput.data"
              />
            </CCol>
            <CCol sm="6" md="6" xl="6">
              <BaseInput
                :options="isVerifiedInput.options"
                :data="isVerifiedInput.data"
              />
            </CCol>
            <CCol sm="6" md="6" xl="6">
              <BaseInput
                :options="userNameInput.options"
                :data="userNameInput.data"
              />
            </CCol>
            <CCol sm="6" md="6" xl="6">
              <BaseInput
                :options="emailInput.options"
                :data="emailInput.data"
              />
            </CCol>
          </CRow>
          <div slot="footer" class="mt-4">
            <CButton
              color="primary"
              @click="submitData"
              class="btn-action-primary"
            >
              <i class="fa fa-refresh"></i> Cập nhật </CButton
            >&nbsp;
          </div>
          <BaseLoading :loading="loading.value"></BaseLoading>
        </CForm>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import BaseSelect from "../base/BaseSelect2";
import BaseInput from "../base/BaseInput";
import BaseLoading from "../base/BaseFormLoading";

export default {
  name: "Profile",
  components: { BaseSelect, BaseLoading, BaseInput },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {
    let that = this;
    return {
      loading: { value: false },
      idField: {
        data: {
          name: "id",
          model: ""
        }
      },
      firstNameInput: {
        options: {
          label: "Họ",
          type: "text"
        },
        data: {
          name: "firstName",
          model: "",
          updateCallback: function() {
            that.submitData();
          },
        }
      },
      lastNameInput: {
        options: {
          label: "Tên",
          type: "text"
        },
        data: {
          name: "lastName",
          model: "",
          updateCallback: function() {
            that.submitData();
          },
        }
      },
      fullNameInput: {
        options: {
          label: "Tên đầy đủ *",
          placeholder: "Tên đầy đủ",
          type: "text"
        },
        data: {
          name: "fullName",
          model: "",
          updateCallback: function() {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function() {
              let value = that.fullNameInput.data.model;
              let fullname_regex = /^[a-zA-Z_ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀẾỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪếễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ ]+$/;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Tên đầy đủ không được để trống";
              } else if (value.length < 6) {
                this.isValid = false;
                this.errorMessage = "Tên đầy dủ ít nhất có 6 kí tự";
              } else if (fullname_regex.test(value) == false) {
                this.isValid = false;
                this.errorMessage = "Tên đầy dủ chỉ gồm chữ cái và dấu cách";
              } else if (fullname_regex.test(value) == true) {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
      genderSelect: {
        options: {
          label: "Giới tính",
          filter: false
        },
        data: {
          name: "gender",
          items: [
            { key: "2", value: "Không xác định" },
            { key: "1", value: "Nam" },
            { key: "0", value: "Nữ" }
          ],
          model: ""
        }
      },
      statusInput: {
        options: {
          label: "Trạng thái",
          type: "text",
          disabled: true
        },
        data: {
          name: "status",
          model: "",
          formatter: function(value) {
            return value == 1 ? "Hoạt động" : "Tạm khóa";
          }
        }
      },
      isVerifiedInput: {
        options: {
          label: "Xác minh",
          type: "text",
          disabled: true
        },
        data: {
          name: "isVerified",
          model: "",
          formatter: function(value) {
            return value == 1 ? "Đã xác minh" : "Chưa xác minh";
          }
        }
      },
      userNameInput: {
        options: {
          label: "Tài khoản đăng nhập",
          type: "text",
          disabled: true
        },
        data: {
          name: "userName",
          model: ""
        }
      },
      emailInput: {
        options: {
          label: "Email",
          type: "text",
          disabled: true
        },
        data: {
          name: "email",
          model: ""
        }
      }
    };
  },
  methods: {
    getData: function() {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/user/getProfileUser",
        successCallback: function(response) {
          that.dataCache = that.$helper.setupDataResponse(
            that.$data,
            response.data.data
          );
        },
        errorCallback: function(error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    submitData: function() {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/user/changeProfileUser",
        dataValid: function() {
          return that.dataCache;
      },
        validFalseCallback: function() {
          that.showWarningMsg({
            message: "Xin thay đổi thông tin trước khi cập nhật"
          });
        },
        dataRef: function() {
          return that.$data;
        },
        successCallback: function(response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({
              message: that.$helper.getStringError(response.data.data)
            });
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({
              message: "Cập nhật thông tin tài khoản thành công"
            });
          }
        },
        errorCallback: function(error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    }
  },
  created: function() {},
  mounted: function() {
    this.getData();
  },
  watch: {}
};
</script>
<style scoped></style>
